import { useState } from "react";
import { useCheckoutHelper } from "../../../../hooks/useCheckoutHelper";

export const useCheckoutCustomer = () => {
  const [isActive, setIsActive] = useState(false);
  const { customer, setCustomerInfo } = useCheckoutHelper();

  return {
    customerInfo: customer,
    isActive,
    setIsActive,
    setCustomerInfo,
  };
};
